/**
 * Test IDs for QA automation.
 */
export const testIds = {
  conditionValueSelectorEnterValue: "condition-value-selector-enter-value",
} as const;
